var jquery = require("jquery");
// var cookie = require("jquery.cookie");
window.$ = window.jQuery = jquery;
require('lazysizes');
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.preloadAfterLoad = false;
import Lenis from 'lenis';
import lottie from 'lottie-web';

// Initialize Lenis
window.lenis = new Lenis({
	lerp: 0.05, 
	wheelMultiplier: 1,
});

// Array to store the start and end offsets of heroType1 and ctaType1 sections
let sectionOffsets = [];


let header = $('header');
let lastScrollTop = 0;
const delta = 0.5;
var navbarHeight = $('.headerContainer').outerHeight();


var heroType1 = $('[data-section="heroType1"] .column');
var textType2 = $('[data-section="textType2"] .text-block');
var ctaType1 = $('[data-section="ctaType1"] .image-container');
var imagesType2 = $('[data-section="imagesType2"] .image-container');

lenis.on('scroll', (e) => {

    const st = e.scroll;
	menu(st);

    // Update last scroll position
    lastScrollTop = st;

    const scrollY = e.scroll + header.outerHeight()/2;

	const isDesktop = $(window).width() >= 1024;

	// Read all section offsets up front, before any transform writes below.
	// Interleaving offset() reads with css() writes forces the browser to
	// do a synchronous layout recalculation on every element; batching all
	// reads first avoids that (same values, same result, no forced reflow).
	var textType2Offsets = isDesktop ? textType2.map(function() {
		return $(this).closest('section').offset().top;
	}).get() : [];

	var ctaType1Offsets = isDesktop ? ctaType1.map(function() {
		return $(this).closest('section').offset().top;
	}).get() : [];

	var imagesType2Offsets = imagesType2.map(function() {
		return $(this).closest('section').offset().top;
	}).get();

	if (isDesktop) {
		heroType1.each(function(index) {
			const scrollSpeed = 0.1;
			const offsetY = e.scroll * scrollSpeed;
			$(this).css('transform', 'translateY(' + offsetY + 'px)');
			$(this).closest('section').css('transform', 'translateY(' + (offsetY * 1.5) + 'px)');
		});

		textType2.each(function(index) {
			var sectionOffset = textType2Offsets[index];
			var initialOffset = 200;
			var scrollPosition = e.scroll - sectionOffset + initialOffset;
			var freezeOffset = 50;
			var maxOffset = 100;
			var scrollSpeed = 0.3;
			var offsetY;

			if (index == 0) {
				offsetY = (-1) * scrollPosition * scrollSpeed;
				if (offsetY > ((-1) * freezeOffset) && offsetY < 0) {
					offsetY = 0;
				}
			}
			if (index == 1) {
				offsetY = 0;
			}
			if (index == 2) {
				offsetY = scrollPosition * scrollSpeed;
				if (offsetY < freezeOffset && offsetY > 0) {
					offsetY = 0;
				}
			}
			if (offsetY < (-1) * maxOffset) {
				offsetY = (-1) * maxOffset;
			}
			if (offsetY > maxOffset) {
				offsetY = maxOffset;
			}
			var offsetYRem = offsetY / 16;
			$(this).css('transform', 'translateY(' + offsetYRem + 'rem)');
		});

		ctaType1.each(function(index) {
			var sectionOffset = ctaType1Offsets[index];
			var initialOffset = 200;
			var scrollPosition = e.scroll - sectionOffset + initialOffset;  // Make scroll relative to the section
			var scrollSpeed = 0.3;
			var offsetY = (-1) * scrollPosition * scrollSpeed;
			$(this).css('transform', 'translateY(' + offsetY + 'px)');
		});
	}

	imagesType2.each(function(index) {
		var sectionOffset = imagesType2Offsets[index];
		var initialOffset = 200;
		var scrollPosition = e.scroll - sectionOffset + initialOffset;  // Make scroll relative to the section
		var scrollSpeed = 0.3;
		var offsetY = (-1) * scrollPosition * scrollSpeed;
		$(this).css('transform', 'translateY(' + offsetY + 'px)');
	});
});

// Use requestAnimationFrame to continuously update the scroll
function raf(time) {
	lenis.raf(time);
	requestAnimationFrame(raf);
}

function menu(st) {

    if (Math.abs(lastScrollTop - st) > delta) {

		// Check scroll direction and update header classes
		if (st > lastScrollTop && st > navbarHeight) {
			// Scrolled down
			// if (header.hasClass('nav-down')) {
				header.removeClass('nav-down').addClass('nav-up');
			// }
		} else {
			// Scrolled up
			if (st > navbarHeight && (st + $(window).height() < $(document).height())) {
				header.removeClass('nav-up').addClass('nav-down');
				// header.closest('section').attr('data-bg','secondary-four');
			}

			if (st < 50) {
				header.removeClass('nav-up nav-down');
				// if ($('body.offset').length) {
				// 	header.closest('section').attr('data-bg','secondary-one');
				// }
			}
		}
	}
}


import ScrollOut from "scroll-out";

ScrollOut({
	cssProps: {
		viewportY: true,
	},
});




// READY

$(function () {

	// console.log('Website proudly by Imagic Creative');

	requestAnimationFrame(raf);

	var st = $(window).scrollTop();
	menu(st);

	var firstSection = $('main').find('section[data-section]').first();
	if (firstSection.length) {
		var bg = firstSection.attr('data-bg');
		if (bg == 'white') {
			$('header').addClass('header-black');
		}
	}

	// var headerMixed = true;
    // sectionOffsets.forEach((section) => {
	// 	// console.log(section)
    //     if (scrollY >= section.start && scrollY <= section.end) {
	// 		headerMixed = false;
    //     }
    // });
	// if (headerMixed) {
	// 	header.addClass('header-mixed');
	// } else {
	// 	header.removeClass('header-mixed');
	// }


	// Waves only play while on screen. The breakpoint-hidden footer wave (display: none)
	// never loads, and the menu/search waves start when their panel slides in and pause
	// when it closes, so nothing animates off screen. Footer waves load a screen early
	// so their first frame is already drawn when they scroll into view.
	var lottieWaves = [
		{ el: $('.wave-desktop')[0], path: '/dist/animation/FooterAnimation_Desktop.json', preload: true },
		{ el: $('.wave-mobile')[0], path: '/dist/animation/FooterAnimation_Mobile.json', preload: true },
		{ el: $('.wave-menu')[0], path: '/dist/animation/MenuAnimation.json' },
		{ el: $('.wave-menu-2')[0], path: '/dist/animation/MenuAnimation.json' },
	].filter(function(wave) {
		return wave.el;
	});

	function loadLottieWave(wave) {
		if (!wave.anim) {
			wave.anim = lottie.loadAnimation({
				container: wave.el,
				renderer: 'svg',
				loop: true,
				autoplay: false,
				path: wave.path,
			});
		}
		return wave.anim;
	}

	if ('IntersectionObserver' in window) {
		// Not used for the menu/search waves: their closed panels sit just above the
		// viewport, so a margin would load them on every page load.
		var lottiePreloadObserver = new IntersectionObserver(function(entries) {
			entries.forEach(function(entry) {
				if (entry.isIntersecting) {
					loadLottieWave(entry.target.lottieWave);
					lottiePreloadObserver.unobserve(entry.target);
				}
			});
		}, { rootMargin: '100% 0px' });

		var lottiePlayObserver = new IntersectionObserver(function(entries) {
			entries.forEach(function(entry) {
				var wave = entry.target.lottieWave;
				if (entry.isIntersecting) {
					loadLottieWave(wave).play();
				} else if (wave.anim) {
					wave.anim.pause();
				}
			});
		});

		lottieWaves.forEach(function(wave) {
			wave.el.lottieWave = wave;
			if (wave.preload) {
				lottiePreloadObserver.observe(wave.el);
			}
			lottiePlayObserver.observe(wave.el);
		});
	} else {
		lottieWaves.forEach(function(wave) {
			loadLottieWave(wave).play();
		});
	}

	resizeVideo();


});

////////////////////




// SCROLL

$(window).on('scroll', function(e) {

	// didScroll = true;

});

////////////////////




// RESIZE

$(window).on('resize', function() {

	resizeVideo();

});

////////////////////




// SEARCH

var searchBundleLoaded = false;
var searchBundleLoading = false;

function loadSearchBundle() {
	if (searchBundleLoaded || searchBundleLoading || !window.searchBundleUrl) {
		return;
	}
	searchBundleLoading = true;
	var script = document.createElement('script');
	script.src = window.searchBundleUrl;
	script.onload = function() {
		searchBundleLoaded = true;
		searchBundleLoading = false;
	};
	document.body.appendChild(script);
}

$(document).on('click', '[data-search-trigger]', function(e) {
	$('[data-menu-trigger][data-menu-revealed="true"]').trigger('click');
	var revealed = $(this).attr('data-search-revealed');
	var st = $(window).scrollTop();
	if (revealed == 'false') {
		lenis.stop();
		if (st >= 20) {
			$('header').removeClass('nav-down').addClass('nav-up');
		}
		$('body').attr('data-search-revealed','true');
		$('aside.search-popup-section').attr('data-search-revealed','true');
		$('aside.search-popup-section').attr('data-container-revealed','true');
		loadSearchBundle();
	} else {
		lenis.start();
		if (st >= 20) {
			$('header').removeClass('nav-down').addClass('nav-up');
		}
		$('body').attr('data-search-revealed','false');
		$('aside.search-popup-section').attr('data-search-revealed','false');
		setTimeout(() => {
			$('aside.search-popup-section').attr('data-container-revealed','false');
		}, 1000);
	}
});

////////////////////




// MENU

$(document).on('click', '[data-menu-trigger]', function(e) {
	var revealed = $(this).attr('data-menu-revealed');
	var st = $(window).scrollTop();
	if (revealed == 'false') {
		lenis.stop();
		if (st >= 20) {
			header.removeClass('nav-up nav-down');
		}
		$(this).text('Close');
		$(this).attr('data-menu-revealed','true');
		$('body').attr('data-menu-revealed','true');
		$('aside.main-menu').attr('data-menu-revealed','true');
		$('aside.main-menu').attr('data-container-revealed','true');
	} else {
		lenis.start();
		if (st >= 20) {
			header.addClass('nav-up');
		}
		$(this).text('Menu');
		$(this).attr('data-menu-revealed','false');
		$('body').attr('data-menu-revealed','false');
		$('aside.main-menu').attr('data-menu-revealed','false');
		setTimeout(() => {
			$('aside.main-menu').attr('data-container-revealed','false');
		}, 1000);
	}
});

$(document).on('click', '[data-trigger-submenu]', function(e) {
	var submenu = $(this).parent().parent().find('.link-children');
	var revealed = submenu.attr('data-submenu-revealed');
	var allTriggers = $('[data-trigger-submenu]');
	var allSubmenus = $('.link-children');
	allTriggers.attr('data-submenu-revealed','false');
	allSubmenus.attr('data-submenu-revealed','false');
	allSubmenus.slideUp(300);
	if (revealed == 'false') {
		$(this).attr('data-submenu-revealed','true');
		submenu.attr('data-submenu-revealed','true');
		submenu.slideDown(300);
	} else {
		$(this).attr('data-submenu-revealed','false');
		submenu.attr('data-submenu-revealed','false');
		submenu.slideUp(300);
	}
});

////////////////////




// FILTER - SPACES

let jsonData;

$(document).on('click', '[data-filter-spaces] [data-filter-trigger]', function(e) {
	var filter = $(this).attr('data-filter-trigger');
	var revealed = $(this).attr('data-revealed');
	$('[data-filter-trigger]').attr('data-revealed', 'false');
	$('[data-filter-options]').slideUp(300);
	if (revealed == 'false') {
		$(this).attr('data-revealed', 'true');
		$('[data-filter-options="' + filter + '"]').slideDown(300);
        $('[data-filter-options="' + filter + '"]').slideDown(300, function() {
			var display = 'flex';
			if (filter == 'seating') {
				display = 'grid';
			}
            $(this).css('display', display);  // Set display to grid after slideDown
        });
	} else {
		$(this).attr('data-revealed', 'false');
		$('[data-filter-options="' + filter + '"]').slideUp(300);
	}
});

$(document).on('click', '[data-filter-spaces] [data-filter-value]', function(e) {
	var filter = $(this).closest('[data-filter-options]').attr('data-filter-options');
	$('[data-filter-options="' + filter + '"]').find('[data-filter-value]').removeClass('active');
	$(this).addClass('active');
	var filterName = $(this).text();
	if (filter == 'seating') {
		filterName = $(this).attr('data-filter-name');
	}
	if (filterName == 'Stagebanquet') {
		filterName = 'Stage banquet';
	}
	if (filterName == 'Halfmode') {
		filterName = 'Half mode';
	}
	if (filterName == 'Exhibitionstand') {
		filterName = 'Exhibition stand';
	}
	$('[data-filter-trigger="' + filter + '"] span').text(' — ' + filterName);
	$('[data-filter-trigger="' + filter + '"] span').attr('data-filter-value', $(this).attr('data-filter-value'));

	$('[data-section="filterSpaces"] [data-filter-trigger]').attr('data-revealed', 'false');
	$('[data-section="filterSpaces"] [data-filter-options]').slideUp(300);
	filterSpaces();
});

$('body').on('click', function(event) {
	// console.log(event.target)
	if (
		!$(event.target).hasClass('filter') && 
		!$(event.target).parent().hasClass('filter') && 
		!$(event.target).parent().hasClass('filter-container')
	) {
		$('[data-filter-spaces] [data-filter-trigger]').attr('data-revealed', 'false');
		$('[data-filter-spaces] [data-filter-options]').slideUp(300);
	}
});

async function filterSpaces() {
    var filters = {};
    $('[data-filter-spaces] [data-filter-trigger]').each(function() {
        var filterName = $(this).attr('data-filter-trigger');
        var filterValue = $(this).find('span').attr('data-filter-value');
        if (filterValue && filterValue !== 'all') {
            filters[filterName] = filterValue;
        }
    });

    var queryString = $.param(filters);

    // console.log('Fetching spaces.json with filters:', queryString);

	// OCCASION to SEATING VISUAL FILTERING
	if (filters['occasion'] !== undefined) {

		$('[data-filter-options="seating"] [data-filter-value!="all"]').addClass('hide');

		switch (filters['occasion']) {
			case 'meeting':
				var valuesToShow = ['theatre', 'boardroom', 'cabaret', 'classroom'];
				valuesToShow.forEach(function(value) {
					$(`[data-filter-options="seating"] [data-filter-value="${value}"]`).removeClass('hide');
				})
				break;
			case 'conference':
				var valuesToShow = ['exhibitionstand', 'classroom', 'theatre', 'cabaret', 'boardroom'];
				valuesToShow.forEach(function(value) {
					$(`[data-filter-options="seating"] [data-filter-value="${value}"]`).removeClass('hide');
				})
				break;

			case 'trade-show':
				var valuesToShow = ['exhibitionstand']
				valuesToShow.forEach(function(value) {
					$(`[data-filter-options="seating"] [data-filter-value="${value}"]`).removeClass('hide');
				})
				break;

			case 'dinner':
				var valuesToShow = ['cocktail', 'banquet', 'cabaret', 'stagebanquet']
				valuesToShow.forEach(function(value) {
					$(`[data-filter-options="seating"] [data-filter-value="${value}"]`).removeClass('hide');
				})
				break;
		
			default:
				$('[data-filter-options="seating"] [data-filter-value]').removeClass('hide');
				break;
		}
	} else {
		$('[data-filter-options="seating"] [data-filter-value]').removeClass('hide');
	}

    try {
        const response = await $.ajax({
            type: 'get',
            url: '/spaces.json?' + queryString,
        });
        
        // console.log('success /spaces.json?' + queryString);
        jsonData = response.data;
        // console.log(jsonData);

        // Create an array of IDs from jsonData
        var filteredIds = jsonData.map(function(item) {
            return item.id;
        });

        $('.space-block').each(function() {
            var spaceId = parseInt($(this).attr('data-id'));
			// console.log('spaceId ' + spaceId)
            if (filteredIds.includes(spaceId)) {
                $(this).show();

				var seatingBlocks = $(this).find('.seating-block');
				var needsOpacity = {};
				seatingBlocks.each(function() {
					var seatingBlockId = $(this).attr('data-seating');
					needsOpacity[seatingBlockId] = false; // Initially set to false, meaning no opacity
				});

				if (filters['capacity'] !== undefined) {
					var regex = /^(\d+)-(\d+)$/;
					var matches = filters['capacity'].match(regex);
					if (matches) {
						var minCapacity = parseInt(matches[1], 10); // comes from filter	
						var maxCapacity = parseInt(matches[2], 10); // comes from filter
						seatingBlocks.each(function() {
							var seatingBlockId = $(this).attr('data-seating');
							var minCapacityData = parseInt($(this).attr('data-min-capacity'), 10); // comes from entry
							var maxCapacityData = parseInt($(this).attr('data-max-capacity'), 10); // comes from entry
							if (isOverlapping(minCapacityData, maxCapacityData, minCapacity,maxCapacity)) {
								needsOpacity[seatingBlockId] = true;
							} else {
								needsOpacity[seatingBlockId] = false;
							}
						})
					} else {
						console.log('Invalid format');
					}
				}
				if (filters['seating'] !== undefined) {
					// console.log(filters['seating'])
					seatingBlocks.each(function() {
						var seatingBlockId = $(this).attr('data-seating');
						var seatingData = $(this).attr('data-seating');
						if (seatingData == filters['seating']) {
							needsOpacity[seatingBlockId] = true;
						} else {
							needsOpacity[seatingBlockId] = false;
						}
					})
				}

				seatingBlocks.each(function() {
					var seatingBlockId = $(this).attr('data-seating');
					if (needsOpacity[seatingBlockId]) {
						$(this).addClass('text-primary-one active');
					} else {
						$(this).removeClass('text-primary-one active');
					}
				});

            } else {
                $(this).hide();
            }
        });

    } catch (error) {
        // console.log('error spaces.json');
        console.log(error);
    }
}

////////////////////




// LIST TYPE 1

$(document).on('click', '[data-section="listType1"] .list-heading', function(e) {
	var revealed = $(this).attr('data-revealed');
	if (revealed == 'false') {
		$(this).find('.link').text('Less');
		$(this).attr('data-revealed','true');
		$(this).parent().find('.list-content').slideDown(300);
	} else {
		$(this).find('.link').text('More');
		$(this).attr('data-revealed','false');
		$(this).parent().find('.list-content').slideUp(300);
	}
});

////////////////////




// FILTER - EVENTS

let currentPage_E = 1;
let loading_E = false;
let currentCategory_E = 'all';
let cardsEl_E = $('section[data-section="filterEvents"] .column-cards');
let loadMoreEl_E = $('section[data-section="filterEvents"] [data-load-more]');

// Handle category filter click
$(document).on('click', 'section[data-section="filterEvents"] [data-filter-trigger="category"]', function (e) {
    e.preventDefault();

    // if (loading_E) return; // Prevent multiple clicks

    currentCategory_E = $(this).attr('data-filter-value'); // Get selected category
    currentPage_E = 1; // Reset to the first page

    // Mark the clicked category as active
    $('[data-filter-trigger="category"]').removeClass('active');
    $(this).addClass('active');

    // Clear existing events and load filtered events
    cardsEl_E.empty();
	// console.log('currentPage_E ' + currentPage_E)
	// console.log('currentCategory_E ' + currentCategory_E)
    loadMoreEvents(currentPage_E, currentCategory_E);
});

// Load more events when the button is clicked
$(document).on('click', 'section[data-section="filterEvents"] [data-load-more]', function (e) {
    e.preventDefault();

    if (loading_E) return; // Prevent multiple clicks
    loading_E = true;

    currentPage_E++;
    loadMoreEvents(currentPage_E, currentCategory_E);
});

async function loadMoreEvents(page, category = 'all') {
    try {
        const response = await $.ajax({
            type: 'get',
            url: `/events.json?page=${page}&category=${category}`,
        });

        // console.log('Loaded page ' + page, response);

        let events = response.data; // Assuming the response contains an array of event data
        let limit = 8; // Assuming the response contains an array of event data
        if (events.length > 0) {
            events.forEach(function (event) {
                // Create the HTML structure for each event
				// console.log(event)

                // Append the event to the column-cards container
                cardsEl_E.append(event.html);
				limit = event.limit;
            });

            loading_E = false; // Allow loading more pages
        }
		// console.log('limit ' + limit)
		// console.log('events.length ' + events.length)
		if (events.length < limit || events.length == 0) {
            loadMoreEl_E.attr('data-load-more','false');
		} else {
            loadMoreEl_E.attr('data-load-more','true');
		}

    } catch (error) {
        console.log('Error loading more events:', error);
    }
}

////////////////////




// FILTER - NEWS

let currentPage_N = 1;
let loading_N = false;
let currentCategory_N = 'all';
let cardsEl_N = $('section[data-section="filterNews"] .column-cards');
let loadMoreEl_N = $('section[data-section="filterNews"] [data-load-more]');

// Handle category filter click
$(document).on('click', 'section[data-section="filterNews"] [data-filter-trigger="category"]', function (e) {
    e.preventDefault();

    if (loading_N) return; // Prevent multiple clicks

    currentCategory_N = $(this).attr('data-filter-value'); // Get selected category
    currentPage_N = 1; // Reset to the first page

    // Mark the clicked category as active
    $('[data-filter-trigger="category"]').removeClass('active');
    $(this).addClass('active');

    // Clear existing events and load filtered events
    cardsEl_N.empty();
    loading_N = true;
    
    // Load initial 7 articles for the selected category
    loadInitialNews(currentCategory_N);
});

// Load more events when the button is clicked
$(document).on('click', 'section[data-section="filterNews"] [data-load-more]', function (e) {
    e.preventDefault();

    if (loading_N) return; // Prevent multiple clicks
    loading_N = true;

    // Load all remaining articles for current category
    loadRemainingNews(currentCategory_N);
});

// Load initial 7 articles (for category changes or page load)
async function loadInitialNews(category = 'all') {
    try {
        const categoryParam = category !== 'all' ? `&category=${category}` : '';
        const response = await $.ajax({
            type: 'get',
            url: `/news.json?${categoryParam}`,
        });

        let articles = response.data;
        
        if (articles.length > 0) {
            articles.forEach(function (article) {
                cardsEl_N.append(article.html);
            });
        }

        if (articles.length === 7) {
            loadMoreEl_N.attr('data-load-more', 'true');
        } else {
            loadMoreEl_N.attr('data-load-more', 'false');
        }

        loading_N = false;

    } catch (error) {
        console.log('Error loading initial articles:', error);
        loading_N = false;
    }
}

// Load all remaining articles (for load more button)
async function loadRemainingNews(category = 'all') {
    try {
        const categoryParam = category !== 'all' ? `&category=${category}` : '';
        const response = await $.ajax({
            type: 'get',
            url: `/news.json?loadAll=true${categoryParam}`,
        });

        let articles = response.data;
        
        if (articles.length > 0) {
            articles.forEach(function (article) {
                cardsEl_N.append(article.html);
            });
        }

        loadMoreEl_N.attr('data-load-more', 'false');
        loading_N = false;

    } catch (error) {
        console.log('Error loading remaining articles:', error);
        loading_N = false;
    }
}
////////////////////




// FILTER - GALLERY

let currentPage_G = 1;
let loading_G = false;
let currentCategory_G = 'all';
let cardsEl_G = $('section[data-section="filterGallery"] .column-cards');
let loadMoreEl_G = $('section[data-section="filterGallery"] [data-load-more]');
let ids_G = $('section[data-section="filterGallery"]').attr('data-ids');

// Handle category filter click
$(document).on('click', 'section[data-section="filterGallery"] [data-filter-trigger="category"]', function (e) {
    e.preventDefault();
	loadMoreEl_G.attr('data-load-more','false');

    // if (loading_G) return; // Prevent multiple clicks

    currentCategory_G = $(this).attr('data-filter-value'); // Get selected category
    currentPage_G = 1; // Reset to the first page

    // Mark the clicked category as active
    $('[data-filter-trigger="category"]').removeClass('active');
    $(this).addClass('active');

    // Clear existing events and load filtered events
    cardsEl_G.empty();
	// console.log('currentPage_G ' + currentPage_G)
	// console.log('currentCategory_G ' + currentCategory_G)
    loadMoreGallery(currentPage_G, currentCategory_G);
});

// Load more events when the button is clicked
$(document).on('click', 'section[data-section="filterGallery"] [data-load-more]', function (e) {
    e.preventDefault();

    if (loading_G) return; // Prevent multiple clicks
    loading_G = true;

    currentPage_G++;
    loadMoreGallery(currentPage_G, currentCategory_G);
});

async function loadMoreGallery(page, category = 'all') {
    try {
        const response = await $.ajax({
            type: 'get',
            url: `/gallery.json?ids=${ids_G}&page=${page}&category=${category}`,
        });

        // console.log(`/gallery.json?ids=${ids_G}&page=${page}&category=${category}`);
        // console.log('Loaded page ' + page, response);

        let events = response.data; // Assuming the response contains an array of event data
        let limit = 8; // Assuming the response contains an array of event data
        if (events.length > 0) {
            events.forEach(function (event) {
                // Create the HTML structure for each event
				// console.log(event)

                // Append the event to the column-cards container
                cardsEl_G.append(event.html);
				limit = event.limit;
            });

            loading_G = false; // Allow loading more pages
        }
		// console.log('limit ' + limit)
		// console.log('events.length ' + events.length)
		if (events.length < limit || events.length == 0) {
            loadMoreEl_G.attr('data-load-more','false');
		} else {
            loadMoreEl_G.attr('data-load-more','true');
		}

    } catch (error) {
        console.log('Error loading more gallery:', error);
    }
}

////////////////////




// POPUPS - TEAM AND GALLERY

let galleryPopupRequest = null;
let galleryCloseCleanupTimer = null;
/** Matches `duration-1000` on aside.filterGallery-popup close transition + small buffer */
const FILTER_GALLERY_CLOSE_CLEANUP_MS = 1050;

function schedulePopupHeaderHide() {
	setTimeout(() => {
		header.removeClass('nav-down').addClass('nav-up');
	}, 400);
	setTimeout(() => {
		header.removeClass('nav-down').addClass('nav-up');
	}, 600);
	setTimeout(() => {
		header.removeClass('nav-down').addClass('nav-up');
	}, 1000);
	setTimeout(() => {
		header.removeClass('nav-down').addClass('nav-up');
	}, 1500);
}

function openFilterGalleryPopup(uid) {
	var $host = $('#filterGallery-popup-host');
	if (!$host.length) {
		return;
	}
	if (galleryCloseCleanupTimer) {
		clearTimeout(galleryCloseCleanupTimer);
		galleryCloseCleanupTimer = null;
	}
	if (galleryPopupRequest && galleryPopupRequest.abort) {
		galleryPopupRequest.abort();
	}

	lenis.stop();
	$('body').attr('data-menu-revealed', 'true');
	$host.attr('data-popup', uid);
	$host.addClass('filterGallery-popup--loading');
	$host.find('.filterGallery-popup__body').html('<div class="filterGallery-popup__loading p3">Loading…</div>');
	$host.attr('data-popup-revealed', 'true');
	$host.attr('data-container-revealed', 'true');
	schedulePopupHeaderHide();

	galleryPopupRequest = $.ajax({
		url: '/gallery-popup.json?uid=' + encodeURIComponent(uid),
		type: 'get',
		dataType: 'json',
	})
		.done(function (res) {
			var data = res && res.html !== undefined ? res : res && res.data;
			if ($host.attr('data-popup') !== uid) {
				return;
			}
			$host.removeClass('filterGallery-popup--loading');
			if (data && data.blurhash) {
				$host[0].style.setProperty('background-image', 'url(' + JSON.stringify(data.blurhash) + ')');
				$host[0].style.setProperty('background-size', 'cover');
			}
			$host.find('.filterGallery-popup__body').html((data && data.html) || '');
		})
		.fail(function (_jq, status) {
			if (status === 'abort') {
				return;
			}
			if ($host.attr('data-popup') !== uid) {
				return;
			}
			$host.removeClass('filterGallery-popup--loading');
			$host.find('.filterGallery-popup__body').html('<div class="filterGallery-popup__loading p3">Could not load image.</div>');
		})
		.always(function () {
			galleryPopupRequest = null;
		});
}

$(document).on('click', '[data-popup-trigger]', function (e) {
	var $t = $(this);
	if ($t.closest('section[data-section="filterGallery"]').length) {
		e.preventDefault();
		openFilterGalleryPopup($t.attr('data-popup-trigger'));
		return;
	}

	lenis.stop();
	$('body').attr('data-menu-revealed', 'true');
	var uid = $t.attr('data-popup-trigger');
	$('aside[data-popup="' + uid + '"]').attr('data-popup-revealed', 'true');
	$('aside[data-popup="' + uid + '"]').attr('data-container-revealed', 'true');
	if (uid == 'filterSpaces-popup') {
		$('aside.filterSpaces-popup [data-filter-trigger]').first().trigger('click');
	}
	schedulePopupHeaderHide();
});

$(document).on('click', '[data-trigger-popup-close]', function (e) {
	if (galleryPopupRequest && galleryPopupRequest.abort) {
		galleryPopupRequest.abort();
		galleryPopupRequest = null;
	}
	if (galleryCloseCleanupTimer) {
		clearTimeout(galleryCloseCleanupTimer);
		galleryCloseCleanupTimer = null;
	}
	$('body').attr('data-menu-revealed', 'false');
	$('aside[data-popup]').attr('data-popup-revealed', 'false');
	$('#filterGallery-popup-host').attr('data-popup-revealed', 'false');
	setTimeout(() => {
		$('aside[data-popup]').attr('data-container-revealed', 'false');
		$('#filterGallery-popup-host').attr('data-container-revealed', 'false');
	}, 300);
	galleryCloseCleanupTimer = setTimeout(function () {
		galleryCloseCleanupTimer = null;
		var $g = $('#filterGallery-popup-host');
		if ($g.length) {
			$g.removeAttr('data-popup');
			$g.removeAttr('style');
			$g.removeClass('filterGallery-popup--loading');
			$g.find('.filterGallery-popup__body').empty();
		}
	}, FILTER_GALLERY_CLOSE_CLEANUP_MS);
	lenis.start();
});

function getFilterGalleryPopupImageUrl(img) {
	if (!img) return null;
	const cs = img.currentSrc;
	if (cs && !cs.startsWith('data:')) return cs;
	const srcset = img.getAttribute('data-srcset') || img.getAttribute('srcset') || '';
	if (srcset) {
		let best = { w: 0, url: '' };
		srcset.split(',').forEach(function (part) {
			const bits = part.trim().split(/\s+/);
			const url = bits[0];
			if (!url) return;
			const desc = bits[1] || '';
			const w = desc.endsWith('w') ? parseInt(desc, 10) : 0;
			if (w >= best.w) best = { w: w || best.w, url: url };
		});
		if (best.url) return best.url;
		const first = srcset.split(',')[0].trim().split(/\s+/)[0];
		if (first) return first;
	}
	const ds = img.getAttribute('data-src');
	if (ds && !ds.startsWith('data:')) return ds;
	return null;
}

function filenameForGalleryDownload(url, fallbackBase) {
	try {
		const path = new URL(url, location.href).pathname;
		const seg = path.split('/').pop() || '';
		if (seg && seg.includes('.')) return decodeURIComponent(seg.split('?')[0]);
	} catch (e) { /* ignore */ }
	return (fallbackBase || 'gallery-image') + '.jpg';
}

function galleryDownloadMimeAndName(url, fallbackBase) {
	const lower = (url || '').toLowerCase();
	const isPng = lower.includes('.png') || /[?&]fm=png\b/i.test(lower);
	const mime = isPng ? 'image/png' : 'image/jpeg';
	let name = filenameForGalleryDownload(url, fallbackBase);
	if (isPng && !/\.png$/i.test(name)) name = name.replace(/\.(jpe?g|webp)$/i, '') + '.png';
	if (!isPng && !/\.(jpe?g|webp|png)$/i.test(name)) name = name.replace(/\.[^.]+$/, '') + '.jpg';
	return { mime: mime, filename: name };
}

function triggerBlobDownload(blob, filename) {
	const blobUrl = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = blobUrl;
	a.download = filename;
	a.style.display = 'none';
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
	URL.revokeObjectURL(blobUrl);
}

function downloadFilterGalleryImage(img, url, filename, mime) {
	const tryCanvas = function () {
		return new Promise(function (resolve, reject) {
			var draw = function () {
				try {
					if (!img.naturalWidth) {
						reject(new Error('not loaded'));
						return;
					}
					var canvas = document.createElement('canvas');
					canvas.width = img.naturalWidth;
					canvas.height = img.naturalHeight;
					var ctx = canvas.getContext('2d');
					ctx.drawImage(img, 0, 0);
					canvas.toBlob(
						function (blob) {
							if (blob) {
								triggerBlobDownload(blob, filename);
								resolve();
							} else reject(new Error('toBlob'));
						},
						mime,
						mime === 'image/jpeg' ? 0.92 : undefined
					);
				} catch (err) {
					reject(err);
				}
			};
			if (img.complete && img.naturalWidth) draw();
			else img.addEventListener('load', draw, { once: true });
		});
	};

	tryCanvas()
		.catch(function () {
			return fetch(url, { mode: 'cors', credentials: 'omit', cache: 'force-cache' }).then(function (res) {
				if (!res.ok) throw new Error('fetch failed');
				return res.blob();
			}).then(function (blob) {
				triggerBlobDownload(blob, filename);
			});
		})
		.catch(function () {
			window.open(url, '_blank', 'noopener,noreferrer');
		});
}

$(document).on('click', '.fg-popup-download', function (e) {
	e.preventDefault();
	e.stopPropagation();
	const $popup = $(this).closest('aside.filterGallery-popup');
	const img = $popup.find('.image-container img').get(0);
	const url = getFilterGalleryPopupImageUrl(img);
	if (!url) return;
	const uid = $popup.attr('data-popup') || 'image';
	const meta = galleryDownloadMimeAndName(url, 'gallery-' + uid);
	downloadFilterGalleryImage(img, url, meta.filename, meta.mime);
});

$(function () {
	var teamTarget = getUrlParameter('team') ?? false;
	if (teamTarget) {

		var currentUrl = window.location.href;
		currentUrl = decodeURIComponent(currentUrl);
		var url = new URL(currentUrl);
		url.searchParams.delete('team');
		window.history.replaceState({}, document.title, url.toString());

		var section = $('section[data-section="cardsType5"]');
		$([document.documentElement, document.body]).animate({
			scrollTop: section.offset().top - 100
		}, 250);
		$('.cta-block[data-popup-trigger="' + teamTarget + '"]').trigger('click');
	}
});

////////////////////





// FORMS

$(function () {
	var forms = $('[data-freeform]');
	if (forms.length) {
		forms.each(function() {
			dynamicCSRF($(this));
		})
	}
});
async function dynamicCSRF(el) {
    // console.log('dynamicCSRF...');
	var form = el.attr('id');
    try {
        const response = await $.ajax({
            type: 'get',
            url: '/dynamic/csrf?form=' + form,
			dataType: 'json',
        });
		// console.log(response.csrf);
        if (response.csrf) {
			el.find('input[name=formHash]').val(response.hash);
			var csrf = response.csrf;
			el.find('input[name=' + csrf.name + ']').val(csrf.value);
        }
    } catch (error) {
        console.log('dynamicCSRF() error');
        console.log(error);
    }
}

///////////////////////////////////////





// VIDEO

function resizeVideo() {
	var $iframe = $('.video-container iframe');
	if ($iframe.length == 0) {
		return false;
	} 
	var windowWidth = $(window).width();
	var windowHeight = $(window).height();

	// Calculate the aspect ratio of the iframe
	var aspectRatio = 16 / 9; // Standard for Vimeo; adjust if needed

	if (windowWidth / windowHeight > aspectRatio) {
		$iframe.css({
			width: windowWidth,
			height: windowWidth / aspectRatio
		});
	} else {
		$iframe.css({
			width: windowHeight * aspectRatio,
			height: windowHeight
		});
	}
}

///////////////////////////////////////




// COOKIES CONSENT

$(document).ready(function () {
	// Check if user has accepted cookies
	if (!localStorage.getItem('cookiesAccepted')) {
		$('.cookie-banner').fadeIn();
	}

	// Click event to accept cookies
	$('#accept-cookies').click(function () {
		localStorage.setItem('cookiesAccepted', 'true'); // Store preference
		$('.cookie-banner').fadeOut();
	});
});

///////////////////////////////////////




// HELPERS

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};  

function isOverlapping(min1, max1, min2, max2) {
    // return min1 <= max2 && max1 >= min2;
	// return min1 <= min2 && min1 <= max2 && max1 >= min2 && max1 >= max2 
	// return max1 >= min2 && max1 >= max2
	return max1 >= min2
}

///////////////////////////////////////